import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import FooterLinks from "./footer-links";

class Footer extends Component {
  render() {
    return (
      <footer className="pwlp-footer">
        <Container>
          <Row className="pwlp-footer__top">
            <Col lg="4" md="6" className="pwlp-footer__col">
              <div className="pwlp-footer__brand">
                <img
                  src="/logo512.png"
                  alt="PayWeek Logo"
                  className="pwlp-footer__logo"
                />
              </div>

              <ul className="pwlp-footer__list">
                <li>
                  <a href="#home">Home</a>
                </li>
                <li>
                  <a href="#services">Services</a>
                </li>
                <li>
                  <a href="#about">About Us</a>
                </li>
                <li>
                  <a href="#pricing">Pricing</a>
                </li>
                
              </ul>
            </Col>

            <Col lg="4" md="6" className="pwlp-footer__col">
              <h4 className="pwlp-footer__heading">Information</h4>

              <ul className="pwlp-footer__list">
                <li>
                  <Link to="/terms">Terms &amp; Conditions</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
              
                <li>
                  <a href="#contact">Contact Us</a>
                </li>
              </ul>
            </Col>

            <Col lg="4" md="12" className="pwlp-footer__col">
              <h4 className="pwlp-footer__heading">Social</h4>
              <FooterLinks />
            </Col>
          </Row>

          <div className="pwlp-footer__bottom">
            <p>© 2023 PayWeek, Inc. All rights reserved.</p>
          </div>
        </Container>
      </footer>
    );
  }
}

export default Footer;